import axios from 'axios'
import querystring from 'querystring'

// Initial state
const state = {
  users: []
}

// Mutations
const mutations = {
  setUsers (state, users) {
    state.users = users
  }
}

// Actions
const actions = {
  loadUsers ({ commit, state }, ctx) {
    return new Promise((resolve, reject) => {
      // console.log('Get all users')
      commit('setUsers', [])

      // Call the backend
      axios.get('/backend/rest/user')
        .then(response => {
          let users = response.data
          // console.log('Got users: ' + users)
          commit('setUsers', users)
        })
        .catch(error => {
          console.log('Failed to get users: ' + error.response.data)
          reject(Error(error.response.data))
        })
    })
  },
  saveUser ({ commit, state }, user) {
    return new Promise((resolve, reject) => {
      // console.log('Save user ' + user.userName)

      // Call the backend
      axios.post('/backend/rest/user', user)
        .then(response => {
          // console.log('Got response: ' + response)
          // console.log('Response data: ' + response.data)

          this.dispatch('user/loadUsers')

          resolve('Success')
        })
        .catch(error => {
          reject(Error(error.response.data.message))
        })
    })
  },
  resetPassword ({ commit, state }, user) {
    return new Promise((resolve, reject) => {
      // console.log('Reset password for ' + user.userName)
      axios.post('/backend/rest/user/' + user.id + '/resetPassword')
        .then(response => {
          // console.log('Got response: ' + response)
          this.dispatch('user/loadUsers')
          resolve('Success')
        })
        .catch(error => {
          reject(Error(error.response.data.message))
        })
    })
  },
  deleteUser ({ commit, state }, user) {
    return new Promise((resolve, reject) => {
      // console.log('Delete user ' + user.userName)

      // Call the backend
      axios.delete('/backend/rest/user/' + user.id)
        .then(response => {
          // console.log('Got response: ' + response)
          // console.log('Response data: ' + response.data)

          this.dispatch('user/loadUsers')

          resolve('Success')
        })
        .catch(error => {
          reject(Error(error.response.data.message))
        })
    })
  },
  changePassword ({ commit, state }, ctx) {
    return new Promise((resolve, reject) => {
      // console.log('Change password to: ' + ctx.password)

      // Call the backend
      axios.post('/backend/rest/user/changePassword', querystring.stringify({ password: ctx.password }))
        .then(response => {
          // console.log('Got response: ' + response)
          resolve('Success')
        })
        .catch(error => {
          reject(Error(error.response.data.message))
        })
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/user.js